export class RistoranteCassaincloud {
    ristoranteId: string;
    apiKey: string;
    status: string;
    accessToken: string;
    tokenExpiresAt: Date;
    lastSync: Date;
    lastRevenueDownload: Date;
    salesPointId: string;

    constructor() {
        this.ristoranteId = "";
        this.apiKey = "";
        this.status = "";
        this.accessToken = "";
        this.tokenExpiresAt = new Date();
        this.lastSync = new Date();
        this.lastRevenueDownload = new Date();
        this.salesPointId = "";
    }

    static fromJson(json: any): RistoranteCassaincloud {
        let result = new RistoranteCassaincloud();
        result.ristoranteId = json.ristoranteId;
        result.apiKey = json.apiKey;
        result.status = json.status;
        result.accessToken = json.accessToken;
        result.tokenExpiresAt = json.tokenExpiresAt ? new Date(json.tokenExpiresAt) : new Date();
        result.lastSync = json.lastSync ? new Date(json.lastSync) : new Date();
        result.lastRevenueDownload = json.lastRevenueDownload ? new Date(json.lastRevenueDownload) : new Date();
        result.salesPointId = json.salesPointId;
        return result;
    }
}